import { useApiCreate } from '../../../../../lib/HttpService';
import { PATH } from './const';
import { StubbornData } from '../../../../../application/business';

export const useEditionAssetCreate = () => useApiCreate<StubbornData>(PATH);
